import React from "react";
import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";
import ReactHtmlParser from "html-react-parser";
import { useTranslation } from "react-i18next";


const ViewNotificationModal = (props) => {
  const { t } = useTranslation();
  return (
    <Modal
      open={props.open}
      onClose={() => props.closeModal()}
      center
      classNames={{ modal: "admin-modal modal-md" }}
    >
      <div>
        <p className="admin-banner">{t("admin.viewNotification.title")}</p>
      </div>
      <div className="px-2">
        <div className="primary-color weight-600">{t("admin.viewNotification.notificationTitle")}</div>
        <div className="overflow-wrap">
          <p>{props?.data?.title}</p>
        </div>
        <div className="primary-color weight-600">{t("admin.viewNotification.notificationBody")}</div>
        <div className="overflow-wrap">
          <div>{ReactHtmlParser(props?.data?.body)}</div>
        </div>
        <div className="admin-btn">
          <button
            onClick={() => props.closeModal()}
            className="btn secondary-btn "
            type="button"
          >
            {t("common.close")}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default ViewNotificationModal;
